import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ header }) => header;

const makeSelectFileUploadData = () => createSelector(
  store,
  ({ fileData }) => fileData,
);

export {
  makeSelectFileUploadData,
};
